import { c as _c } from "react/compiler-runtime";
export const IconMessenger = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 11.73C3 6.71377 6.93002 3 12 3C17.07 3 21 6.71374 21 11.73C21 16.7462 17.07 20.46 12 20.46C11.0893 20.46 10.2157 20.3398 9.39476 20.114C9.23519 20.0701 9.06549 20.0825 8.91407 20.1493L7.12771 20.9379C6.66041 21.1442 6.13292 20.812 6.11728 20.3013L6.06827 18.7004C6.06226 18.5031 5.97352 18.3188 5.8265 18.1872C4.07533 16.6211 3 14.3538 3 11.73ZM9.23913 10.0888L6.59537 14.2831C6.34165 14.6857 6.83644 15.1392 7.2155 14.8516L10.0553 12.6964C10.2474 12.5506 10.5129 12.5498 10.7058 12.6945L12.8086 14.2716C13.4395 14.7449 14.34 14.5787 14.7606 13.9114L17.4044 9.71704C17.658 9.3145 17.1633 8.86088 16.7842 9.14853L13.9444 11.3038C13.7523 11.4495 13.4868 11.4504 13.2939 11.3056L11.1912 9.72857C10.5602 9.25533 9.65967 9.42148 9.23913 10.0888Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
IconMessenger.displayName = 'IconMessenger';